export default {"src":"/_next/static/image/public/assets/icons/improve.088b42ec190edcfeff7054fc9f1150bf.svg","height":32,"width":33};